import { Route } from '@angular/router';
import { RequestsComponent } from './requests.component';
import { RequestsDetailComponent } from './requests-detail/requests-detail.component';

export const REQUESTS_ROUTES: Route[] = [
  {
    path: '',
    data: { name: 'Terugname aanvragen' },
    children: [
      {
        path: ':id',
        component: RequestsDetailComponent,
        data: { name: 'Details', listPath: '/requests' },
      },
      { path: '', component: RequestsComponent },
    ],
  },
];
